import { Attributes, List, Misc, ModelBase, NeoModel, Rules, Validation } from '@singularsystems/neo-core';
import Group from './Group';
import Branch from './Branch';

@NeoModel
export default class BusinessUnit extends ModelBase {
    static typeName = "BusinessUnit";

    public businessUnitId: number = 0;

    @Attributes.Parent(() => Group)
    public group: Group | null = null;

    @Attributes.Serialisation(Misc.SerialiseType.NotNull)
    public groupId: number | null = null;

    @Rules.StringLength(10)
    @Rules.Required()
    public profitCentre: string = "";

    @Rules.StringLength(50)
    @Rules.Required()
    public profitCentreName: string = "";

    public branches = new List(Branch);

    // Client only properties / methods

    @Attributes.NoTracking()
    public isExpanded = false;

    protected addBusinessRules(rules: Validation.Rules<this>) {
        super.addBusinessRules(rules);
    }

    public toString(): string {
        if (this.isNew || !this.profitCentre) {
            return "New business unit";
        } else {
            return this.profitCentre;
        }
    }
}